import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReactECharts from "echarts-for-react";
import { withTranslation } from "react-i18next";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
} from "reactstrap";
import { get, post } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import { hasPermission, hasRolePermission } from "helpers/rolebased_helper";
import secureLocalStorage from "react-secure-storage";

const Dashboard = (props) => {
  const [employeesData, setEmployeesData] = useState({});
  console.log("employee",employeesData);
  
  const [customerData, setCustomerData] = useState({});
  console.log("customerData",customerData);
  
  const [projectsData, setProjectsData] = useState({});
  console.log("projectsData",projectsData);
  
  const [timesheetData, setTimesheetData] = useState([]);
  console.log("timesheetData",timesheetData);
  

  const employeeId = parseInt(secureLocalStorage.getItem("employeeId"));

  useEffect(() => {
    // debugger;
    fetchData();
    if (employeeId) {
      fetchTimesheets();
    }
  }, []);

const fetchTimesheets = async () => {
  try {
    const response = await post(api.GET_ALL_TIMESHEETS_BY_SEARCH, {
      search: "",
      sortBy: "timesheetCode",
      direction: "ASC",
      timesheetDTO: {
        subscriptionId: 100,
        employeeId: employeeId,
      },
    });

    console.log("respo", response);

    if (response?.data) {
      if (response.data.isManager) {
        setTimesheetData(response.data.managerTimesheets.data || []);
      } else {
        setTimesheetData(response.data.employeeTimesheets.data || []);
      }
    }
  } catch (error) {
    console.error("Error fetching timesheets:", error);
  }
};


  const fetchData = async () => {
    try {
      const custCountData = await get(api.GET_CUSTOMERS_COUNT_DATA);
      if (custCountData) {
        setCustomerData(custCountData);
      }

      const projResponse = await get(api.GET_ALL_PROJECTS_BY_STATUS);
      if (projResponse) {
        setProjectsData(projResponse.paginationResponse.data[0]);
      }

      const empCountData = await get(api.GET_EMPLOYEE_COUNT);
      if (empCountData) {
        setEmployeesData(empCountData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Employees Pie Chart Options
  const employeesChartOptions = {
    title: {
      text: "Employees Status",
      left: "center",
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      bottom: "bottom",
    },
    series: [
      {
        name: "Employees Status",
        type: "pie",
        radius: "50%",
        data: [
          { value: employeesData.activeCount, name: "Active Employees" },
          {
            value: employeesData.inactiveCount,
            name: "Inactive Employees",
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  // Customer Pie Chart Options
  const customerChartOptions = {
    title: {
      text: "Customers Status",
      left: "center",
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      bottom: "bottom",
    },
    series: [
      {
        name: "Customers Status",
        type: "pie",
        radius: "50%",
        data: [
          { value: customerData.activeCustomers, name: "Active Customers" },
          { value: customerData.inactiveCustomers, name: "Inactive Customers" },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  // Project Pie Chart Options
  const projectChartOptions = {
    title: {
      text: "Projects Status",
      left: "center",
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    series: [
      {
        name: "Projects Status",
        type: "pie",
        radius: "50%",
        data: [
          { value: projectsData.yet_TO_START, name: "Yet to Start" },
          { value: projectsData.in_PROGRESS, name: "In Progress" },
          { value: projectsData.completed, name: "Completed" },
          { value: projectsData.delayed, name: "Delayed" },
          { value: projectsData.on_HOLD, name: "On Hold" },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  // Comprehensive Stacked Bar Chart
  const stackedBarOptions = {
    title: {
      text: "Comprehensive Dashboard",
      left: "center",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: [
        "Total",
        "Active",
        "Inactive",
        "Yet to Start",
        "In Progress",
        "Completed",
        "Delayed",
        "On Hold",
      ],
      top: "bottom",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: ["Employees", "Customers", "Projects"],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        name: "Total",
        type: "bar",
        stack: "total",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [
          employeesData.totalCount || 0,
          customerData.totalCount || 0,
          projectsData.totalCount || 0,
        ],
      },
      {
        name: "Active",
        type: "bar",
        stack: "total",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [
          employeesData.activeEmployees || 0,
          customerData.activeCustomers || 0,
          projectsData.activeProjects || 0,
        ],
      },
      {
        name: "Inactive",
        type: "bar",
        stack: "total",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [
          employeesData.inactiveEmployees || 0,
          customerData.inactiveCustomers || 0,
          projectsData.inactiveProjects || 0,
        ],
      },
      {
        name: "Yet to Start",
        type: "bar",
        stack: "status",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [0, 0, projectsData.yet_TO_START || 0],
      },
      {
        name: "In Progress",
        type: "bar",
        stack: "status",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [0, 0, projectsData.in_PROGRESS || 0],
      },
      {
        name: "Completed",
        type: "bar",
        stack: "status",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [0, 0, projectsData.completed || 0],
      },
      {
        name: "Delayed",
        type: "bar",
        stack: "status",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [0, 0, projectsData.delayed || 0],
      },
      {
        name: "On Hold",
        type: "bar",
        stack: "status",
        label: { show: true },
        emphasis: { focus: "series" },
        data: [0, 0, projectsData.on_HOLD || 0],
      },
    ],
  };

  // Timesheet Stacked Bar Chart Options
  const timesheetChartOptions = {
    title: {
      text: "Timesheet Hours by Date",
      left: "center",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: (params) => {
        let result = `${params[0].name}<br/>`;
        params.forEach((item) => {
          if (item.value > 0) {
            result += `${item.marker} ${item.seriesName}: ${item.value} hours<br/>`;
          }
        });
        return result;
      },
    },
    legend: {
      top: "bottom",
      data: timesheetData.map(
        (ts) => `${ts.timesheetCode} (${ts.projectName})`
      ),
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "15%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: Array.from(
        new Set(
          timesheetData.flatMap((ts) => Object.keys(ts.dailyHours)).sort()
        )
      ).map((date) => date.slice(5)), // Format date as MM-DD
    },
    yAxis: {
      type: "value",
      name: "Hours",
    },
    series: timesheetData.map((ts, index) => ({
      name: `${ts.timesheetCode} (${ts.projectName})`,
      type: "bar",
      stack: "hours",
      label: {
        show: true,
        position: "inside",
        formatter: (params) => (params.value > 0 ? params.value : ""),
      },
      emphasis: {
        focus: "series",
      },
      data: Array.from(
        new Set(timesheetData.flatMap((t) => Object.keys(t.dailyHours)).sort())
      ).map((date) => ts.dailyHours[date]?.hours || 0),
      itemStyle: {
        color: ["#5470C6", "#91CC75", "#FAC858", "#EE6666", "#73C0DE"][
          index % 5
        ], // Distinct colors for each timesheet
      },
    })),
  };

  document.title = "Dashboard | Elbert Technology";
  // console.log(employeeId);

  const isAccountant = hasRolePermission(7);
  return (
    <React.Fragment>
      <div className="page-content px-4">
        {hasPermission("Administration", "View") && (
          <Container fluid>
            <Row>
              <Col lg={6} className="mb-4">
                <Card>
                  <CardHeader>
                    <CardTitle>Employees Breakdown</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <ReactECharts option={employeesChartOptions} />
                  </CardBody>
                </Card>
              </Col>
              <Col lg={6} className="mb-4">
                <Card>
                  <CardHeader>
                    <CardTitle>Customers Breakdown</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <ReactECharts option={customerChartOptions} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader>
                    <CardTitle>Projects Status</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <ReactECharts option={projectChartOptions} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col lg={12}>
                <Card>
                  <CardHeader>
                    <CardTitle>Comprehensive Dashboard</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <ReactECharts option={stackedBarOptions} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
        {employeeId ? (
          <Container>
            <Row className="mt-4">
              <Col lg={12}>
                <Card>
                  <CardHeader>
                    <CardTitle>Timesheet Hours Breakdown</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <ReactECharts option={timesheetChartOptions} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        ): ""}
        {
          isAccountant && "Accountant Dashboards Coming soon"
        }

      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
